export const QA_NAME_EDIT_MANAGER_MODAL = 'editManager'

export const TASK_EDIT_MANAGER_FIELDS_FIELD_NAME = 'manager_id'

export const TASK_EDIT_MANAGER_FIELDS_INITIAL_VALUES = {
  [TASK_EDIT_MANAGER_FIELDS_FIELD_NAME]: null,
}
